import React from 'react';
import { TStripePriceTier } from '@/features/credits/apiSlice';
// eslint-disable-next-line camelcase
import { TMP_formatNumber } from '@/features/credits/utils';
import { PLAN_NAMES } from '@/features/credits/components/utils';
import { Link } from 'react-router-dom';
import {
  CreditsRange,
  CreditsRangeCell,
  PlanNameColumn,
  Table,
  TableHeader,
  UsageCell,
} from './styled-components';

export const TiersTable: React.FC<{
  selectedTiers: Maybe<TStripePriceTier[]>;
  selectedPlan: string;
}> = ({ selectedTiers, selectedPlan }) => {
  return (
    <Table>
      <thead>
        <tr>
          <TableHeader>Plan</TableHeader>
          <TableHeader>Credit range</TableHeader>
          <TableHeader>Price</TableHeader>
          <th />
        </tr>
      </thead>

      <tbody>
        {selectedTiers?.map((tier, i) => {
          const planName =
            i === 0 ? (
              <PlanNameColumn rowSpan={selectedTiers.length}>
                {PLAN_NAMES[selectedPlan]}
              </PlanNameColumn>
            ) : null;

          const currentTier = tier.isCurrent ? (
            <UsageCell>
              ← Your current usage (
              <Link to="../credits">
                {TMP_formatNumber(tier.currentUsage || 0)}
              </Link>
              )
            </UsageCell>
          ) : (
            <td />
          );
          return (
            <tr key={i}>
              {planName}
              <CreditsRangeCell colSpan={2} isCurrent={tier.isCurrent}>
                <CreditsRange>
                  <span>
                    {TMP_formatNumber(tier.from)}-
                    {tier.upTo ? TMP_formatNumber(tier.upTo) : '∞'}
                  </span>
                  <span>${TMP_formatNumber(tier.price / 100)}</span>
                </CreditsRange>
              </CreditsRangeCell>
              {currentTier}
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
};
